@if (category$ | async; as components) {
  @for (component of components.component; track component; let i = $index) {
    @if (component.typeCode ===cmsItemType) {
      <app-custom-cms-item [isGrid]="true" [item]="component"></app-custom-cms-item>
    }
    @if (component.typeCode===carouselType) {
      <div class="carousel-wrapper">
        <div class="container">
          <div class="product-carousel">
            @switch (component.titleTag) {
              @case ('H1') {
                <h1 class="h1-component"
                  [style]="'font-weight :'+ (component.titleBold == 'true' ? 'bold' : '400') +';font-size: '+ component.titleSize +'px; color: '+ component.titleColor">
                {{component.title}}</h1>
              }
              @case ('H2') {
                <h2 class="h1-component"
                  [style]="'font-weight :'+ (component.titleBold == 'true' ? 'bold' : '400') +';font-size: '+ component.titleSize +'px; color: '+ component.titleColor">
                {{component.title}}</h2>
              }
              @default {
                <div class="h1-component"
                  [style]="'font-weight :'+ (component.titleBold == 'true' ? 'bold' : '400') +';font-size: '+ component.titleSize +'px; color: '+ component.titleColor">
                {{component.title}}</div>
              }
            }
            @if (isMobile() | async) {
              <cx-carousel [items]="items$ | async" [itemWidth]="'50%'" [hideIndicators]="true"
              [template]="categoryProducts" [animation]="animation"></cx-carousel>
            } @else {
              <cx-carousel [items]="items$ | async" [itemWidth]="'300px'" [hideIndicators]="true"
              [template]="categoryProducts" [animation]="animation"></cx-carousel>
            }
          </div>
          <ng-template #categoryProducts let-item="item">
            <app-custom-product-item [item]="item"></app-custom-product-item>
          </ng-template>
        </div>
      </div>
    }
  }
  @if (searchResults$ | async; as searchResults) {
    @if (searchResults?.title) {
      <h1 class="h3-component">{{ searchResults?.title }}</h1>
    } @else {
      @if (searchResults?.breadcrumbs) {
        <h1 class="h3-component">{{ searchResults?.breadcrumbs[0]?.facetValueName }}</h1>
      }
    }
    @if (searchResults.categoryLongDescription) {
      <div class="long-description" [innerHTML]="searchResults?.categoryLongDescription"></div>
    }
  }
}